import { IPmListFilterParams } from 'PreventionPackage/MainModule/interfaces/IPmListFilterParams';
import { apiPost } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { IKnmIndexPage } from 'APIPackage/KnmModule/interfaces/IKnmIndexPage';

export async function fetchPmFindIndex(
  page: number,
  size: number,
  filter: IPmListFilterParams | null,
  order?: string,
): Promise<IKnmIndexPage> {
  const params = new URLSearchParams();

  params.append('page', String(page));
  params.append('size', String(size));
  if (order) {
    params.append('order', order);
  }

  return apiPost<IKnmIndexPage>({
    url: `${getServiceBaseURL(APIServiceEnum.INDEX_SERVICE)}/knm/find-indexes-pm?${params}`,
    body: filter,
  });
}
